import * as React from "react";
import { Trans } from "react-i18next";
import {
  BalanceUpdateInstantTournamentAwardDetailsFragmentFragment,
} from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";

export const BalanceUpdateInstantTournamentAwardDetails = ({
                                                             details,
                                                           }: {
  details: BalanceUpdateInstantTournamentAwardDetailsFragmentFragment;
}) => {
  return (
    <div>
      <Trans
        className="flex"
        i18nKey="notification.balance_update_instant_tournament"
        components={{ name: <span className="font-bold" /> }}
        values={{
          instantTournamentName: details.tournamentName || ""
        }}
      />
    </div>
  );
};
